import Entities from 'STORE';

import { askAndFinishActiveCall } from './askAndFinishActiveCall';

export const askAndDeleteActiveCall = async (): Promise<boolean> => {
  if (!Entities.Calls.ongoingCall || !Entities.Calls.ongoingCall.channelId) {
    return true;
  }

  const askResult = await askAndFinishActiveCall(
    Entities.Calls.ongoingCall.channelId,
    Entities.usersStore.Me.id,
    Entities.Calls.ongoingCall.callInfo.deviceId,
    'calls_switch_to_another_call_message'
  );

  if (!askResult) {
    return false;
  }

  await Entities.Calls.ongoingCall?.delete();

  return true;
};
